import baseAPI from '@/http'

const router = 'api/configuracao'

export const configuracaoAPI = {
    list: () => baseAPI.get(`${router}`),
}
